
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.0061 7C10.0061 7.55229 9.55855 8 9.00651 8C8.45446 8 8.00694 7.55229 8.00694 7V6C8.00694 3.79086 9.79702 2 12.0052 2H18.0017C20.2099 2 22 3.79086 22 6V18C22 20.2091 20.2099 22 18.0017 22H11.9983C9.79008 22 8 20.2091 8 18V17C8 16.4477 8.44752 16 8.99957 16C9.55161 16 9.99913 16.4477 9.99913 17V18C9.99913 19.1046 10.8942 20 11.9983 20H18.0017C19.1058 20 20.0009 19.1046 20.0009 18V6C20.0009 4.89543 19.1058 4 18.0017 4H12.0052C10.9011 4 10.0061 4.89543 10.0061 6V7Z","fill":"#10001F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.2929 8.29289C11.9024 8.68342 11.9024 9.31658 12.2929 9.70711L13.5858 11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H13.5858L12.2929 14.2929C11.9024 14.6834 11.9024 15.3166 12.2929 15.7071C12.6834 16.0976 13.3166 16.0976 13.7071 15.7071L16.7071 12.7071C17.0976 12.3166 17.0976 11.6834 16.7071 11.2929L13.7071 8.29289C13.3166 7.90237 12.6834 7.90237 12.2929 8.29289Z","fill":"#10001F"}})])
          )
        }
      }
    